import * as Sentry from "@sentry/react";
import dayjs from 'dayjs';
import dayjsUtc from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/ru';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {ThemeConfig} from "antd";
import {RouterProvider} from "react-router";
import {router} from "./router.tsx";
import {Providers} from "./Providers.tsx";

if(location.hostname === 'events.vatrus.info') {
    Sentry.init({
        dsn: "https://08c90780858d4bcabadc1e0cdcd3d3e9@o4508993894612992.ingest.de.sentry.io/4509810491064400",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", /^https:\/\/events\.vatrus\.info\/api/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        enableLogs: true
    });
}

dayjs.extend(dayjsUtc);
dayjs.extend(dayjsTimezone);
dayjs.extend(customParseFormat)
dayjs.locale('ru');
dayjs.tz.setDefault('Etc/UTC');

const theme = {
    components: {
        Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
        },
        Statistic: {
            contentFontSize: 18
        }
    },
    cssVar: true
} as ThemeConfig;

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Providers theme={theme}>
            <RouterProvider router={router} />
        </Providers>
    </StrictMode>,
)